import { render, staticRenderFns } from "./DeliveryTimeDiscount.vue?vue&type=template&id=70732cbb"
import script from "./DeliveryTimeDiscount.vue?vue&type=script&lang=js"
export * from "./DeliveryTimeDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports